import React, { Component } from "react";
import { withApollo } from "react-apollo";
import { Queries, Mutations } from "../../../../../graphql";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { Tabs, Spin, Form, Button, Modal, message } from "antd";
import Container from "../../../../../components/user/Container";
import { getToken } from "../../../../../utils/auth";
import { fetchAPI } from "../../../../../utils/fetchApiAxios";
import axiosAPI, { urlAttachFile } from "../../../../../config/axiosAPI";
import { checkLinkURL } from "../../../../../utils/auth";
import axios from "axios";
import { apiKeyNews } from "../../../../../utils/apiKey";
import ModalConfirmForm from "../../../../../components/user/ModalConfirmForm";
import { alertMessage } from "../../../../../utils/message";
//sector
import SecAttachment from "../sector/SecAttachment";
import SecHistory from "../sector/SecHistory";
import SecDocDetail from "../sector/SecDocDetail";
import moment from "moment";

const { TabPane } = Tabs;

class WelfareListPaymentVictim extends Component {
  state = {
    loading: false,
    loadingFullpage: false,
    preLoadOnsubmit: false,
    deletedAttachmentRecord: [],
    isApproveModeNoti: false
  };

  getTermFeeDetailById = async () => {
    const { token } = getToken();
    const { match } = this.props;

    const API_DEVICE_KEY = atob(apiKeyNews());

    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
      apiKey: API_DEVICE_KEY,
    };

    let idDetail = {
      // headers: headers,
      studyEducationFeeId: match.url.split("/")[5],
    };

    console.log('match.url.split("/")[5]', match.url.split("/")[5]);

    const DataFetchAPI = await axiosAPI.get(
      `
         ${checkLinkURL()}/getTermFeeDetailById`,
      {
        params: { ...idDetail },
      }
    );

    console.log("DataFetchAPI history", DataFetchAPI);

    if (DataFetchAPI.data.data) {
      console.log("response.data termfee", DataFetchAPI.data.data);
      console.log(
        "DataFetchAPI.data termfee studyEducationFeeDetail",
        DataFetchAPI.data.data.studyEducationFeeDetail
      );

      const attachInvoiceData =
        DataFetchAPI.data.data.studyEducationFeeDetail?.filter(
          (item) => item.studyFeeDetailType == "INVOICE"
        );

      console.log(
        "studyEducationFeeDetail 2",
        DataFetchAPI.data.data.studyEducationFeeDetail
      );

      const attachOthersData =
        DataFetchAPI.data.data.studyEducationFeeDetail?.filter(
          (item) => item.studyFeeDetailType != "INVOICE"
        );

      console.log("attachInvoiceData", attachInvoiceData);
      console.log("attachOthersData", attachOthersData);

      await this.setState({
        dataScholar: DataFetchAPI.data.data,
        loadingFullpage: false,
        attachInvoiceData: attachInvoiceData,
        attachOthersData: attachOthersData,
        //isEdit: DataFetchAPI.data.data.approveStatus == "draft" ? true : false,
      });
      await this.getHistoryTermfees(DataFetchAPI.data.data.studyLeaveRequestId);
    } else {
      await this.setState({
        loadingFullpage: false,
      });
    }
  };

  getDropdownAttachment = async () => {
    const { token } = getToken();
    const { match } = this.props;

    const API_DEVICE_KEY = atob(apiKeyNews());

    let config = {
      dropDownType: "feeDocument",
      refCode: "",
      exceptValue: [
        {
          value: "INVOICE",
        },
      ],
    };

    //  const DataFetchAPI = await fetchAPI(
    //    config,
    //    "POST",
    //    "https://uat-vtrcapi.redcross.or.th" + "/getDropDownList"
    //  );

    const DataFetchAPI = await axiosAPI.post(
      `${checkLinkURL()}/getDropDownList`,
      config
    );

    console.log("DataFetchAPI", DataFetchAPI);

    if (DataFetchAPI.data.status) {
      await this.setState({
        dropdownAttachment: DataFetchAPI.data.data,
        loadingFullpage: false,
        //isEdit: response.data.data.approveStatus == "draft" ? true : false,
      });
    }
  };

  getHistoryTermfees = async (studyLeaveRequestId) => {
    const { client, location, match } = this.props;
    const { empCode } = this.state;
    await this.setState({
      loadingFullpage: true,
    });

    let idDetail = {
      studyLeaveRequestId: studyLeaveRequestId,
    };
    console.log("idDetail", idDetail);

    try {
      // const DataFetchAPI = await fetchAPI(
      //   idDetail,
      //   "GET",
      //   "https://uat-vtrcapi.redcross.or.th/" +
      //     "getStudyEducationFeePaidHistory/"
      // );

      const DataFetchAPI = await axiosAPI.get(
        `${checkLinkURL()}/getStudyEducationFeePaidHistory`,
        { params: { ...idDetail } }
      );

      console.log("DataFetchAPI history", DataFetchAPI);

      if (DataFetchAPI.data.data) {
        await this.setState({
          dataTermfeeHistory: DataFetchAPI.data.data,
          loadingFullpage: false,
        });
      } else {
        await this.setState({
          loadingFullpage: false,
        });
      }
    } catch (error) {
      this.setState({
        preLoadOnsubmit: false,
        loadingFullpage: false,
      });
      console.log("error", error);
    }
  };

  handleSubmit = async (e, statusSend) => {
    const { form, match } = this.props;
    const {
      dataAbstain,
      dataProfile,
      dataEmployeeOrg,
      dataWelfare,
      deletedAttachmentRecord,
      dataScholar,
    } = this.state;

    e.preventDefault();

    form.validateFields(async (err, values) => {
      console.log("xczzxczcz handlesub", values);

      if (err) {
        let title = "";
        switch (statusSend) {
          case "reject":
            title = "ไม่อนุมัติการเบิกค่าธรรมเนียมการศึกษาไม่สำเร็จ";
            break;
          case "moreinfo":
            title = "ส่งเรื่องกลับไม่สำเร็จ";
            break;
          default:
            title = "อนุมัติการเบิกค่าธรรมเนียมการศึกษาไม่สำเร็จ";
            break;
        }
        Modal.error({
          className: "modalFickIcons",
          title,
          width: "600px",
          content: <h3 className="mt-3">กรุณาระบุข้อมูลให้ครบถ้วน</h3>,
          okText: "ปิด",
          onOk() {},
        });
      } else {
        let valuesAdd = {};
        valuesAdd.approveAction = statusSend;
        valuesAdd.studyEducationFeeId = dataScholar.studyEducationFeeId;
        valuesAdd.studyLeaveRequestId = dataScholar.studyLeaveRequestId;
        valuesAdd.studyEducationDocumentNo =
          dataScholar.studyEducationDocumentNo;
        valuesAdd.studyLeaveDocumentNo =
          dataScholar.studyLeaveRequest.studyLeaveDocumentNo;
        // valuesAdd.studyEducationFeeTerm = dataScholar.studyEducationFeeTerm; //can edit
        //valuesAdd.studyEducationFeeYear = dataScholar.studyEducationFeeYear; //can edit
        valuesAdd.paymentType = dataScholar.paymentType; //can edit
        // valuesAdd.submitDate = moment(); //dataScholar.submitDate;  //can edit
        valuesAdd.bankAccountNo = dataScholar.bankAccountNo;
        valuesAdd.bankBranch = dataScholar.bankBranch;
        valuesAdd.bankCode = dataScholar.bankCode;
        valuesAdd.bankName = dataScholar.bankName;
        valuesAdd.paymentDate = moment(); //dataScholar.paymentDate;
        //valuesAdd.studyEducationActualPrice = parseFloat(values.studyFeeDetailActualPrice);
        // valuesAdd.submitDate = values.submitDate ;

        //delete values.studyFeeDetailActualPrice

        let errorMinAttach = false;
        let errorNoValidate = false;

        let dateSlipInvalid = false;
        let dateSlipMaxInvalid = false;

         console.log("dateSubmitSubtract ja1",values)

        let dateSubmitSubtract = moment(values.submitDate)
          .subtract(1, 'year')
          .add(1, 'day')
          .startOf('day');

        if (
          !values.studyEducationFeeDetail ||
          values.studyEducationFeeDetail?.length == 0
        ) {
          errorMinAttach = true;
        }

        console.log("dateSubmitSubtract ja",dateSubmitSubtract)
        if (values.studyEducationFeeDetail) {
          values.studyEducationFeeDetail.map((valueMap, keys) => {
            if (!valueMap.isValidate) {
              errorNoValidate = true;
            } else {
              delete valueMap.isValidate;
              if (
                moment(valueMap.studyFeeDetailSlipDate).isAfter(
                  values.submitDate,"day")
              ) {
                dateSlipInvalid = true;
              }
              if(moment(valueMap.studyFeeDetailSlipDate).isBefore(
                  dateSubmitSubtract,"day")){
                 dateSlipMaxInvalid = true;
                }
            }
          });
        }
        if (deletedAttachmentRecord) {
          deletedAttachmentRecord.map((valueMap, keys) => {
            valueMap.isDeleted = 1;
            delete valueMap.disabledRow;
            delete valueMap.isShowEditButton;
            delete valueMap.isShowSaveButton;
            delete valueMap.isValidate;
          });
        }
        console.log(
          "deletedAttachmentRecord after true",
          deletedAttachmentRecord
        );

        let attachMerge = [];
        if (
          values.studyEducationFeeDetail &&
          values.studyEducationFeeDetailAttach
        ) {
          attachMerge = values.studyEducationFeeDetail.concat(
            values.studyEducationFeeDetailAttach
          );
          valuesAdd.studyEducationFeeDetail = attachMerge;
        } else if (
          values.studyEducationFeeDetail &&
          !values.studyEducationFeeDetailAttach
        ) {
          attachMerge = values.studyEducationFeeDetail;
          valuesAdd.studyEducationFeeDetail = attachMerge;
        } else if (
          !values.studyEducationFeeDetail &&
          values.studyEducationFeeDetailAttach
        ) {
          attachMerge = values.studyEducationFeeDetailAttach;
          valuesAdd.studyEducationFeeDetail = attachMerge;
        }

        console.log("attachMerge", attachMerge);

        delete values.studyEducationFeeDetailAttach;
        delete values.studyEducationFeeDetail;
        delete values.studyFeeDetailSlipDate;

        let valuesSend = {
          ...values,
          ...valuesAdd,
        };

        if (valuesSend.studyEducationFeeDetail) {
          const mergeAttach = valuesSend?.studyEducationFeeDetail.concat(
            deletedAttachmentRecord
          );
          valuesSend.studyEducationFeeDetail = mergeAttach;

          valuesSend.studyEducationFeeDetail.map((valueReturn, keys) => {
            valueReturn.studyFeeDetailSort = keys + 1;
            // if (valueReturn?.studyFeeDetailType) {
              if (valueReturn?.studyEducationFeeAttachfile?.length > 0) {
                let studyFeeAttachment =
                  valueReturn?.studyEducationFeeAttachfile;

                //            if(valueReturn?.studyEducationFeeAttachfile.length > 1){
                //             valueReturn.studyEducationFeeAttachfile[1].studyFeeAttachmentId = valueReturn.studyEducationFeeAttachfile[0].studyFeeAttachmentId
                //             valueReturn.studyEducationFeeAttachfile[1].isDeleted = 1
                //             valueReturn.studyEducationFeeAttachfile[1].studyFeefilePath = valueReturn.studyEducationFeeAttachfile[0].studyFeefilePath

                //             console.log(" before removed",valueReturn?.studyEducationFeeAttachfile)
                //             valueReturn.studyEducationFeeAttachfile.shift()
                //             // console.log("removed",removed)
                //             // valueReturn.studyEducationFeeAttachfile = removed
                //  }

                console.log(
                  "valueReturn?.studyEducationFeeAttachfile",
                  valueReturn?.studyEducationFeeAttachfile
                );

                valuesSend.studyEducationFeeDetail[keys].studyFeeAttachment =
                  valueReturn?.studyEducationFeeAttachfile;
                delete valuesSend.studyEducationFeeDetail[keys]
                  .studyEducationFeeAttachfile;

                  console.log(
                    "valuesSend.studyEducationFeeDetail[keys]",
                    valuesSend.studyEducationFeeDetail
                  );
                  console.log(
                    "valuesSend.studyEducationFeeDetail[keys]",
                    valuesSend.studyEducationFeeDetail[keys]
                  );
              }
            // }
          });
        }

        console.log("valuesend", valuesSend);

        let ModalFormTextArea = true;
        let ModalFormTextAreaRequie = false;

        if (statusSend === "reject" || statusSend === "moreinfo") {
          ModalFormTextAreaRequie = true;
        }

        if (errorMinAttach) {
          Modal.error({
            title: "กรุณาแนบเอกสารแนบใบเสร็จอย่างน้อย 1 รายการ",
            className: "custom-modal-error",
            okText: "ตกลง",
          });
          await this.setState({
            preLoadOnsubmit: false,
            loadingFullpage: false,
          });
        } else if (errorNoValidate) {
          Modal.error({
            title: "มีเอกสารแนบใบเสร็จที่ยังไม่ถูกบันทึก",
            className: "custom-modal-error",
            okText: "ตกลง",
          });
          await this.setState({
            preLoadOnsubmit: false,
            loadingFullpage: false,
          });
        } else if (dateSlipInvalid) {
          Modal.error({
            title: "มีข้อมูลวันที่ในใบเสร็จที่ไม่ถูกต้อง",
            className: "custom-modal-error",
            okText: "ตกลง",
          });
          await this.setState({
            preLoadOnsubmit: false,
            loadingFullpage: false,
          });
        } 
        else if (dateSlipMaxInvalid) {
          Modal.error({
            title: "มีข้อมูลวันที่ในใบเสร็จอายุเกิน 1 ปี",
            className: "custom-modal-error",
            okText: "ตกลง",
          });
          await this.setState({
            preLoadOnsubmit: false,
            loadingFullpage: false,
          });
        } 
        else {
          //   let titleModal =
          //   statusSend == "reject"
          //     ? "ท่านต้องการไม่อนุมัติรายการเบิกเงินสวัสดิการ?"
          //     : "ท่านต้องการอนุมัติรายการเบิกเงินสวัสดิการ?";

          // await this.showModalFormConfirm(
          //   valuesSend,
          //   titleModal,
          //   "",
          //   "ตกลง",
          //   ModalFormTextArea,
          //   ModalFormTextAreaRequie
          // );
          await this.sendToApproves(valuesSend, statusSend);
        }
      }
    });
  };

  showModalFormConfirm = async (
    values,
    messageShow,
    title,
    textBtnOK,
    ModalFormTextArea,
    ModalFormTextAreaRequie
  ) => {
    const { form, client } = this.props;

    await this.setState({
      ModalConfirmFormTitle: messageShow,
      ModalConfirmFormSubTitle: title,
      ModalConfirmFormShowModal: true,
      ModalConfirmFormBtnOk: textBtnOK,
      ModalConfirmFormBtnCancel: "ยกเลิก",
      ModalConfirmFormValue: values,
      ModalFormTextArea,
      ModalFormTextAreaRequie,
    });
  };

  hideModalConfirm = async () => {
    await this.setState({
      ModalConfirmFormTitle: null,
      ModalConfirmFormSubTitle: null,
      ModalConfirmFormShowModal: false,
      ModalConfirmFormBtnOk: null,
      ModalConfirmFormBtnCancel: null,
      ModalConfirmFormValue: null,
    });
  };

  checkBeforeSendByAPI = async (valuesCreate) => {
    // await this.setState({
    //   preLoadOnsubmit: true,
    //   loadingFullpage: true,
    // });

    console.log("valuesSendCreate valuesCreate", valuesCreate);

    let detailRemoveDelete = [];

    valuesCreate.studyEducationFeeDetail.map((valueMap, keys) => {
      console.log("eiei isdelete = 0 ", valueMap.isDeleted);
      if (
        valueMap.studyFeeDetailType?.toUpperCase() != "INVOICE"
      ) {
        valueMap.studyFeeDetailExpenses = ""
        valueMap.studyFeeDetailType = ""
      }
    });


    valuesCreate.studyEducationFeeDetail.map((valueMap, keys) => {
      console.log("eiei isdelete = 0 ", valueMap.isDeleted);
      if (
        valueMap.isDeleted == 0 &&
        valueMap.studyFeeDetailType?.toUpperCase() == "INVOICE"
      ) {
        console.log("eiei isdelete = 0 ", valueMap);
        detailRemoveDelete.push(valueMap);
      }
    });

    let valuesSendCreate = {
      studyLeaveRequestId: valuesCreate.studyLeaveRequestId,
      studyEducationActualPrice: valuesCreate.studyEducationActualPrice,
      studyEducationFeeTerm: valuesCreate.studyEducationFeeTerm,
      studyEducationFeeYear: valuesCreate.studyEducationFeeYear,
      studyEducationFeeDetail: detailRemoveDelete,
      studyEducationFeeId: valuesCreate.studyEducationFeeId, //รอapiเพิ่มfield
    };

    console.log("valuesSendCreate", valuesSendCreate);

    //  const DataFetchAPI = await fetchAPI(
    //    valuesSendCreate,
    //    "POST",
    //    "https://uat-vtrcapi.redcross.or.th" + "/checkTermFeeCondition"
    //  );

    const DataFetchAPI = await axiosAPI.post(
      `${checkLinkURL()}/checkTermFeeCondition`,
      valuesSendCreate
    );
    console.log("DataFetchAPI", DataFetchAPI);

    if (DataFetchAPI.data.status) {
      let ModalFormTextArea = true;
      let ModalFormTextAreaRequie = false;

      if (
        valuesCreate?.approveAction === "reject" ||
        valuesCreate?.approveAction === "moreinfo"
      ) {
        ModalFormTextAreaRequie = true;
      }

      if (DataFetchAPI.data.data.result.toUpperCase() == "SUCCESS") {
        let titleModal = "";
        switch (valuesCreate?.approveAction) {
          case "reject":
            titleModal = "ท่านต้องการไม่อนุมัติรายการเบิกเงินสวัสดิการ?";
            break;
          case "moreinfo":
            titleModal = "ท่านต้องการส่งเรื่องกลับ?";
            break;
          default:
            titleModal = "ท่านต้องการอนุมัติรายการเบิกเงินสวัสดิการ?";
            break;
        }
        await this.showModalFormConfirm(
          valuesCreate,
          titleModal,
          "",
          "ตกลง",
          ModalFormTextArea,
          ModalFormTextAreaRequie
        );
        //await this.finalSendToCreate(valuesCreate)
      } else if (DataFetchAPI.data.data.result.toUpperCase() == "INFO") {
        await this.showModalFormConfirm2(
          valuesCreate,
          "",
          DataFetchAPI.data.data.msgName,
          "",
          "ส่งดำเนินการ",
          "ยกเลิก",
          ModalFormTextArea,
          ModalFormTextAreaRequie
        );
      } else {
        //message.error(DataFetchAPI.data.data.msgName);
 await this.showModalFormConfirmTermFee(
          valuesCreate,
          `${DataFetchAPI.data.data.msgName} ท่านต้องการดำเนินการต่อ?`,
          "",
          "ตกลง",
          '',
          false
        );

        await this.setState({
          preLoadOnsubmit: false,
          loadingFullpage: false,
        });
      }
    } else {
      message.error("พบข้อผิดพลาด กรุณาติดต่อผู้ดูแลระบบ");
      await this.setState({
        preLoadOnsubmit: false,
        loadingFullpage: false,
      });
    }
  };

  finalSendToCreate = async (values) => {
    // await this.setState({
    //   preLoadOnsubmit: true,
    //   loadingFullpage: true,
    // });

    console.log("valuesSendCreate valuesCreate", values);

    values.approveDescription = values.ModalNoteApprove;
    delete values.ModalNoteApprove;

    await this.hideModalConfirm2();
    const { token } = getToken();
    const { match, history } = this.props;
    const API_DEVICE_KEY = atob(apiKeyNews());

    // await this.setState({
    //   loadingFullpage: true,
    // });

    const headers = {
      //"Content-Type": 'multipart/form-data',
      Authorization: `Bearer ${token}`,
      apiKey: API_DEVICE_KEY,
    };

    //   const objectToFetchApi = {
    //       values
    //    }
    const DataFetchAPI = await axiosAPI.post(
      `
         ${checkLinkURL()}/approveStudyEducation`,
      values
    );

    console.log("DataFetchAPI history", DataFetchAPI);

    if (DataFetchAPI.data.data) {
      console.log("response", DataFetchAPI);
      if (DataFetchAPI.data.status) {
        let messageShow = "";
        switch (values.approveAction) {
          case "reject":
            messageShow = "ไม่อนุมัติรายการเบิกค่าธรรมเนียมการศึกษาเรียบร้อย";
            break;
          case "moreinfo":
            messageShow = "ทำการส่งเรื่องกลับเรียบร้อย";
            break;
          default:
            messageShow = "ทำการอนุมัติรายการเบิกค่าธรรมเนียมการศึกษาเรียบร้อย";
            break;
        }
        alertMessage("success", messageShow);
        setTimeout(() => {
          // window.location.href = "/welfare/welfareApproveList";
          history.push(`/welfare/welfareApproveList`);
        }, 2000);
      } else {
        let messageShow = "";
        switch (values.approveAction) {
          case "reject":
            messageShow = "ไม่อนุมัติรายการเบิกค่าธรรมเนียมการศึกษาไม่สำเร็จ";
            break;
          case "moreinfo":
            messageShow = "ทำการส่งเรื่องกลับไม่สำเร็จ";
            break;
          default:
            messageShow = "ทำการอนุมัติรายการเบิกค่าธรรมเนียมการศึกษาไม่สำเร็จ";
            break;
        }
        alertMessage("error", messageShow);
      }
    } else {
      await this.setState({
        loadingFullpage: false,
      });
    }
  };

  handleSubmitCheckTermFee = async (values) => {

    await this.hideModalCheckTermFee()

    let ModalFormTextArea = true;
      let ModalFormTextAreaRequie = false;

      if (
        values?.approveAction === "reject" ||
        values?.approveAction === "moreinfo"
      ) {
        ModalFormTextAreaRequie = true;
      }


let titleModal = "";
        switch (values?.approveAction) {
          case "reject":
            titleModal = "ท่านต้องการไม่อนุมัติรายการเบิกเงินสวัสดิการ?";
            break;
          case "moreinfo":
            titleModal = "ท่านต้องการส่งเรื่องกลับ?";
            break;
          default:
            titleModal = "ท่านต้องการอนุมัติรายการเบิกเงินสวัสดิการ?";
            break;
        }
        await this.showModalFormConfirm(
          values,
          titleModal,
          "",
          "ตกลง",
          ModalFormTextArea,
          ModalFormTextAreaRequie
        );

  }
  showModalFormConfirm2 = async (
    values,
    status,
    title,
    subtitle,
    btnButton,
    btnCancel,
    ModalFormTextArea2,
    ModalFormTextAreaRequie2
  ) => {
    const { statusSubmit } = this.state;

    await this.setState({
      ModalConfirmFormTitle2: title,
      ModalConfirmFormSubTitle2: "",
      ModalConfirmFormShowModal2: true,
      ModalConfirmFormBtnOk2: btnButton,
      ModalConfirmFormBtnCancel2: btnCancel,
      ModalConfirmFormValue2: values,
      ModalFormTextArea2,
      ModalFormTextAreaRequie2,
    });
  };


  showModalFormConfirmTermFee = async (
    values,
    messageShow,
    title,
    textBtnOK,
    ModalFormTextArea,
    ModalFormTextAreaRequie
  ) => {
    const { form, client } = this.props;

    await this.setState({
      ModalConfirmFormTitle3: messageShow,
      ModalConfirmFormSubTitle3: title,
      ModalConfirmFormShowModal3: true,
      ModalConfirmFormBtnOk3: textBtnOK,
      ModalConfirmFormBtnCancel3: "ยกเลิก",
      ModalConfirmFormValue3: values,
      ModalFormTextArea3:ModalFormTextArea,
      ModalFormTextAreaRequie3:ModalFormTextAreaRequie,
    });
  };

  hideModalConfirm2 = async () => {
    await this.setState({
      ModalConfirmFormTitle2: null,
      ModalConfirmFormSubTitle2: null,
      ModalConfirmFormShowModal2: false,
      ModalConfirmFormBtnOk2: null,
      ModalConfirmFormBtnCancel2: null,
      ModalConfirmFormValue2: null,
      preLoadOnsubmit: false,
      loadingFullpage: false,
    });
  };

    hideModalCheckTermFee = async () => {
    await this.setState({
      ModalConfirmFormTitle3: null,
      ModalConfirmFormSubTitle3: null,
      ModalConfirmFormShowModal3: false,
      ModalConfirmFormBtnOk3: null,
      ModalConfirmFormBtnCancel3: null,
      ModalConfirmFormValue3: null,
      preLoadOnsubmit: false,
      loadingFullpage: false,
    });
  };

  sendToApproves = async (values) => {
    const { rawData } = this.props;
    const { dataAbstain, dataProfile, dataEmployeeOrg } = this.state;

    await this.hideModalConfirm();

    // values.approveDescription = values.ModalNoteApprove;
    // delete values.ModalNoteApprove;

    console.log("sendToApproves data", values);

    await this.checkBeforeSendByAPI(values);
  };

  deletedAttachment = async (record) => {
    const { deletedAttachmentRecord } = this.state;
    deletedAttachmentRecord.push(record);

    console.log("deletedAttachmentId", deletedAttachmentRecord);
    await this.setState({
      deletedAttachmentRecord,
    });
  };

  async componentDidMount() {

    if(window?.location?.search){
    const query = new URLSearchParams(window.location.search);
    const isApproveModeNoti = query.get('isApproveMode') === 'true' ? true : false;
    await this.setState({
      isApproveModeNoti
    });
    }

    await this.getTermFeeDetailById();
    await this.getDropdownAttachment();
  }

  render() {
    const { match, location = null } = this.props;
    const {
      loadingFullpage,
      preLoadOnsubmit,
      dataScholar,
      attachInvoiceData,
      attachOthersData,
      ModalConfirmFormTitle,
      ModalConfirmFormSubTitle,
      ModalConfirmFormShowModal,
      ModalConfirmFormBtnOk,
      ModalConfirmFormBtnCancel,
      ModalConfirmFormValue,
      ModalFormTextArea,
      ModalFormTextAreaRequie,
      ModalConfirmFormTitle2,
      ModalConfirmFormSubTitle2,
      ModalConfirmFormShowModal2,
      ModalConfirmFormBtnOk2,
      ModalConfirmFormBtnCancel2,
      ModalConfirmFormValue2,
      ModalFormTextArea2,
      ModalFormTextAreaRequie2,
      ModalConfirmFormTitle3,
      ModalConfirmFormSubTitle3,
      ModalConfirmFormShowModal3,
      ModalConfirmFormBtnOk3,
      ModalConfirmFormBtnCancel3,
      ModalConfirmFormValue3,
      ModalFormTextArea3,
      ModalFormTextAreaRequie3,
      dropdownAttachment,
      dataTermfeeHistory,
      isApproveModeNoti
    } = this.state;
    const { getFieldDecorator } = this.props.form;
    {
      console.log("dataScholar", dataScholar);
    }
    return (
      <Container match={match}>
        <div className="breadcrumb-custom pb-3 mb-4">
          <span style={{ fontSize: "18px" }}>
            รายการเบิกเงินสวัสดิการ / เบิกค่าธรรมเนียมการศึกษา / รายละเอียด{" "}
          </span>
        </div>
        <ModalConfirmForm
          title={ModalConfirmFormTitle}
          subtitle={ModalConfirmFormSubTitle}
          showModal={ModalConfirmFormShowModal}
          btnOk={ModalConfirmFormBtnOk}
          btnCancel={ModalConfirmFormBtnCancel}
          submitToSend={this.finalSendToCreate}
          hideModal={this.hideModalConfirm}
          valueConfirm={ModalConfirmFormValue}
          ModalFormTextArea={ModalFormTextArea}
          ModalFormTextAreaRequie={ModalFormTextAreaRequie}
        />
        <ModalConfirmForm
          title={ModalConfirmFormTitle2}
          subtitle={ModalConfirmFormSubTitle2}
          showModal={ModalConfirmFormShowModal2}
          btnOk={ModalConfirmFormBtnOk2}
          btnCancel={ModalConfirmFormBtnCancel2}
          submitToSend={this.finalSendToCreate}
          hideModal={this.hideModalConfirm2}
          valueConfirm={ModalConfirmFormValue2}
          ModalFormTextArea={ModalFormTextArea2}
          ModalFormTextAreaRequie={ModalFormTextAreaRequie2}
        />
        <ModalConfirmForm
          title={ModalConfirmFormTitle3}
          subtitle={ModalConfirmFormSubTitle3}
          showModal={ModalConfirmFormShowModal3}
          btnOk={ModalConfirmFormBtnOk3}
          btnCancel={ModalConfirmFormBtnCancel3}
          submitToSend={this.handleSubmitCheckTermFee}
          hideModal={this.hideModalCheckTermFee}
          valueConfirm={ModalConfirmFormValue3}
          ModalFormTextArea={ModalFormTextArea3}
          ModalFormTextAreaRequie={ModalFormTextAreaRequie3}
        />
        <Spin spinning={loadingFullpage} delay={0}>
          {dataScholar && (
            <Form onSubmit={this.handleSubmitfetchListLearningESS}>
              <div className="card-container" id="page-profile">
                <div className="px-5 py-1 card-bg-green">
                  {dataScholar && dropdownAttachment && (
                    <Tabs type="card" className="my-4" align="center">
                      <TabPane
                        tab={"ข้อมูลการเบิกสวัสดิการ"}
                        key="1"
                        className="mb-0"
                      >
                        <SecDocDetail
                          forceRender
                          rawData={dataScholar}
                          form={this.props.form}
                          dataAttachInvoiceData={attachInvoiceData}
                          isViewOnly={
                            ((location?.state?.isApproveMode || isApproveModeNoti) &&
                            dataScholar?.studyEducationStatus.toUpperCase() ==
                              "PENDING")
                              ? false
                              : true
                          }
                          dataTermfeeHistory={dataTermfeeHistory}
                          onChangeDeletedAttachment={this.deletedAttachment}
                          //isViewOnly={true}
                        />
                      </TabPane>
                      <TabPane
                        tab={"เอกสารแนบ"}
                        key="2"
                        className="mb-0"
                        forceRender
                      >
                        <SecAttachment
                          form={this.props.form}
                          dataAttachOther={attachOthersData}
                          isViewOnly={
                            ((location?.state?.isApproveMode || isApproveModeNoti) &&
                            dataScholar?.studyEducationStatus.toUpperCase() ==
                              "PENDING")
                              ? false
                              : true
                          }
                          //isViewOnly={true}
                          dropdownAttachment={dropdownAttachment}
                          onChangeDeletedAttachment={this.deletedAttachment}
                          forceRender
                        />
                      </TabPane>
                      <TabPane
                        tab={"ประวัติดำเนินการ"}
                        key="3"
                        className="mb-0"
                      >
                        <SecHistory
                          forceRender
                          rawData={dataScholar.studyEducationFeeHistory}
                          form={this.props.form}
                        />
                      </TabPane>
                    </Tabs>
                  )}
                  <div className="mb-4" align="center">
                    <Link
                      to={{
                        pathname: location?.state?.isApproveMode
                          ? "/welfare/welfareApproveList"
                          : "/welfare/welfareList",
                      }}
                    >
                      <Button
                        type="primary"
                        className="mx-2 btn-white-red"
                        disabled={preLoadOnsubmit}
                      >
                        ย้อนกลับ
                      </Button>
                    </Link>
                    {((location?.state?.isApproveMode || isApproveModeNoti) &&
                            dataScholar?.studyEducationStatus.toUpperCase() ==
                              "PENDING") && (
                        <>
                          <Button
                            className="mx-2 btn-white-green"
                            htmlType="submit"
                            onClick={(e) => {
                              this.handleSubmit(e, "moreinfo");
                            }}
                          >
                            ส่งเรื่องกลับ
                          </Button>
                          <Button
                            type="primary"
                            className="mx-2 btn-white-red"
                            htmlType="submit"
                            onClick={(e) => {
                              this.handleSubmit(e, "reject");
                            }}
                            disabled={preLoadOnsubmit}
                          >
                            ไม่อนุมัติ
                          </Button>
                          <Button
                            type="primary"
                            className="ml-2 color-white"
                            htmlType="submit"
                            disabled={preLoadOnsubmit}
                            onClick={(e) => {
                              this.handleSubmit(e, "approve");
                            }}
                          >
                            อนุมัติ
                          </Button>
                        </>
                      )}
                  </div>
                </div>
              </div>
            </Form>
          )}
        </Spin>
      </Container>
    );
  }
}

WelfareListPaymentVictim.defaultProps = {
  autoFocus: false,
};

WelfareListPaymentVictim.propTypes = {
  afterSubmit: PropTypes.func,
  forgotLink: PropTypes.string,
  autoFocus: PropTypes.bool,
};

const WrappedWelfareListPaymentVictim = Form.create()(WelfareListPaymentVictim);

export default withApollo(WrappedWelfareListPaymentVictim);
